import { ActionRegistryItem } from '../ActionRegistryItem';
import { ActionRegistryCategory } from '../ActionRegistryCategory';
export class ActionsDirective extends ActionRegistryCategory {
    label = 'Directive';
    constructor(parent) {
        super(parent);
        super.init();
    }
    showCycleReward = () => new ActionRegistryItem({
        action: ({ app, e }) => app.directive.directivePoseQuestion.poseAnswer(app.cycle.cycleReward.rewardAnswer),
    });
    poseNextReward = () => new ActionRegistryItem({
        action: ({ app, e }) => app.directive.directivePoseQuestion.poseNextReward(),
    });
}
